import { useDisplaySettings } from '@src/providers/AppConfigProvider';
import { supportsBPSPricing, type Security } from '@talos/kyoko';

/**
 * Hook to determine if BPS pricing mode is active for the given security.
 * Returns true when showDelta1BPS is enabled and the security supports BPS pricing.
 *
 * Note: showDelta1BPS is gated by enableDelta1BPSPricingMode at the AppConfigProvider level,
 * so it will be false when the org feature flag is disabled.
 */
export function useIsPricingModeBPS(security?: Security): boolean {
  const { showDelta1BPS } = useDisplaySettings();
  return showDelta1BPS && supportsBPSPricing(security);
}
